import { useCartActions, useCartState } from "@app/_context";
import {
  type ChangeEvent,
  type FormEvent,
  useMemo,
  useRef,
  useState,
} from "react";

export default function useDiscount() {
  const { cart } = useCartState();
  const { addPromotion, removePromotion } = useCartActions();
  const inputRef = useRef<HTMLInputElement>(null);
  const [discountCode, setDiscountCode] = useState(cart?.discountCode || "");

  const isDiscountCodeValid = useMemo(() => {
    return (cart?.discountCode || "").length > 0;
  }, [cart?.discountCode]);

  const isDiscountCodeApplicable = useMemo(() => {
    if (!isDiscountCodeValid) return true;
    return cart?.basketPromotions.some(
      (promotion) => promotion.discountCode === cart.discountCode,
    );
  }, [isDiscountCodeValid, cart?.discountCode, cart?.basketPromotions]);

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    if (cart?.discountCode && cart?.discountCode.length > 0) {
      return handleClear();
    }

    const response = await addPromotion(discountCode, true);

    if (response) {
      if (inputRef.current) {
        inputRef.current.blur();
      }
    }
  }

  async function handleClear() {
    const response = await removePromotion(true);

    if (response) {
      if (inputRef.current) {
        setDiscountCode("");
        inputRef.current.focus();
      }
    }
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setDiscountCode(event.target.value);
  }

  return {
    inputRef,
    discountCode,
    isDiscountCodeValid,
    isDiscountCodeApplicable,
    handleClear,
    handleSubmit,
    handleChange,
  };
}
